import React from 'react'

import { Card, Flex, Separator, styled, Text } from '@driftt/dds'

import { TypeFormats } from 'utils/format'

import { SalesforceIcon } from '../OpportunityTimeline.assets'
import { StyledStatusBadge } from '../OpportunityTimeline.styled'
import { TimelineEventItem } from '../OpportunityTimeline.types'
import { DeprecatedTimelineEventTemplate } from '../TimelineEvent'

type TimelineProps = {
  events: TimelineEventItem[]
}

const StyledFlex = styled(Flex, {
  position: 'relative',
})

const StyledEventCard = styled(Flex, {
  zIndex: 10,
})

const StyledSeparator = styled(Separator, {
  position: 'absolute',
  height: '100%',
  width: '1px',
  backgroundColor: '$gray4',
  left: '50%',
  top: 0,
  zIndex: 0,
})

const VerticalLine = () => {
  return <StyledSeparator orientation="vertical" />
}

type ClosedOpportunityTimelineCardProps = {
  isLoading?: boolean
  stageVariant: 'success' | 'error' | 'pending'
  opportunityStage?: string
  opportunityClosedAtWithZone?: string
}

type CreateOpportunityTimelineCardProps = {
  isLoading?: boolean
  opportunityCreatedAtWithZone?: string
}

//#region TODO: REMOVE THIS

export const DeprecatedClosedOpportunityTimelineCard: React.FC<
  ClosedOpportunityTimelineCardProps
> = ({ stageVariant, opportunityStage, opportunityClosedAtWithZone }) => {
  return (
    <DeprecatedTimelineEventTemplate
      headerLeftElement={<SalesforceIcon />}
      header={
        <Text variant="body">
          Opportunity has closed in <b>Salesforce</b>
        </Text>
      }
      statusBadge={
        <StyledStatusBadge variant={stageVariant} size="small">
          {opportunityStage}
        </StyledStatusBadge>
      }
      date={`${opportunityClosedAtWithZone}`}
    />
  )
}

export const DeprecatedCreateOpportunityTimelineCard: React.FC<
  CreateOpportunityTimelineCardProps
> = ({ opportunityCreatedAtWithZone }) => {
  return (
    <DeprecatedTimelineEventTemplate
      headerLeftElement={<SalesforceIcon />}
      header={
        <Text variant="body">
          Opportunity created in <b>Salesforce</b>
        </Text>
      }
      date={`${opportunityCreatedAtWithZone}`}
    />
  )
}

//#endregion

export const Timeline: React.FC<TimelineProps> = ({ events }) => {
  return (
    <StyledFlex
      fullHeight
      fullWidth
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap={3}
    >
      <VerticalLine />
      {events.map((event, index, array) => {
        const renderDateCard =
          index === 0 || array[index - 1]?.date !== event?.date

        return (
          <StyledEventCard
            direction="column"
            alignItems="center"
            key={`${index}-${event?.date}`}
            gap={3}
          >
            {renderDateCard && (
              <Card css={{ padding: '4px 16px' }}>
                <Card.Content
                  as={Flex}
                  gap={0}
                  direction="row"
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <Text variant="bodyBold">
                    {TypeFormats.HUMAN_READABLE_FULL_DATE(
                      new Date(event?.date || '')
                    )}
                  </Text>
                </Card.Content>
              </Card>
            )}
            {event.component}
          </StyledEventCard>
        )
      })}
    </StyledFlex>
  )
}
